import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  linksSubscribe,
  linksAccount,
  linksContact,
  linksSocial,
  linksMore,
} from '../../constants/constants-footer-links';

/**
 * Site footer.
 * @returns {React.component} The Footer to render.
 */
function Footer(props) {
  const { suppressSubscribeLinks } = props;
  const renderLinks = (arr) => {
    const links = arr.map((link, index) => (
      <li key={index} className="site-footer__list-item">
        <a href={link.link}>{link.label}</a>
      </li>
    ));
    return links;
  };

  const linkContainer = (heading, func) => (
    <Fragment>
      <h3 className="section-heading">{heading}</h3>
      <ul className="site-footer__list">
        {func}
      </ul>
    </Fragment>
  );

  return (
    <footer className="site-footer contain">
      <div className="site-footer__list-container">
        {!suppressSubscribeLinks &&
          linkContainer('Subscribe now', renderLinks(linksSubscribe))
        }
        {linkContainer('My account', renderLinks(linksAccount))}
      </div>
      <div className="site-footer__list-container">
        {linkContainer('Contact', renderLinks(linksContact))}
      </div>
      <div className="site-footer__list-container">
        {linkContainer('Social', renderLinks(linksSocial))}
      </div>
      <div className="site-footer__list-container">
        {linkContainer('More', renderLinks(linksMore))}
      </div>
      <p className="site-footer__copyright">
        © {(new Date()).getFullYear()} Boston Globe Media Partners, LLC
      </p>
    </footer>
  );
}

Footer.propTypes = {
  suppressSubscribeLinks: PropTypes.bool.isRequired,
};

export default Footer;
